import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Projects from "./pages/Projects";
import SellLand from "./pages/SellLand";
import Contact from "./pages/Contact";
import LetterResponse from "./pages/LetterResponse";
import Admin from "./pages/Admin";
import Insights from "./pages/Insights";
import InsightDetail from "./pages/InsightDetail";
import Appraisal from "./pages/Appraisal";
import BookCall from "./pages/BookCall";
import Privacy from "./pages/Privacy";
import Unsubscribe from "./pages/Unsubscribe";
import Watch from "./pages/Watch";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function SiteRoutes() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/sell-your-land" element={<SellLand />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/respond" element={<LetterResponse />} />
        <Route path="/insights" element={<Insights />} />
        <Route path="/insights/:slug" element={<InsightDetail />} />
        <Route path="/appraisal" element={<Appraisal />} />
        <Route path="/book-a-call" element={<BookCall />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/unsubscribe" element={<Unsubscribe />} />
        <Route path="/watch" element={<Watch />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollTop />
        <Routes>
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<SiteRoutes />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
